import { Layout, Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import SidebarMenu from "../Components/Sidebar";
import { useEffect, useState } from "react";
import { getUserDetails } from "../../organisms/MyProfile/ducks/actions";
import { useAppDispatch } from "../../config/hooks";

const { Content } = Layout;
const antIcon = <Loading3QuartersOutlined spin />;

type dashboardProps = {
  loading?: boolean;
  children?: React.ReactNode;
};

const DashboardTemplate = (props: dashboardProps) => {
  const { loading, children } = props;
  const dispatch = useAppDispatch();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (collapsed) {
      document.body.classList.add("sidebar-collapsed");
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  }, [collapsed]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Layout className={collapsed ? "collapsed" : ""}>
        <SidebarMenu collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout>
          <Content>{children}</Content>
        </Layout>
      </Layout>
    </Spin>
  );
};

export default DashboardTemplate;
